"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Increment = Increment;
/** Increments the given string value + 1 */
function Increment(T) {
    return (parseInt(T) + 1).toString();
}
